import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import Field from 'core/components/form/form.v2';
import { SubRiskCollapsibleSection } from './sub-risk-collapsible-section';
import useStyles from './sub-risk.styles';

const WellPumpForm = ({ fieldName, disabled }) => {
  const classes = useStyles();

  return (
    <SubRiskCollapsibleSection
      type="secondary"
      content={<div className={classes.headerText}>Well pump replacement value</div>}
      initialOpen={false}
    >
      <Grid container spacing={2}>
        <Field
          xs={12}
          type="numeric"
          id={`${fieldName}.building.numWellPumps`}
          name={`${fieldName}.building.numWellPumps`}
          mode="dark"
          label="Number of pumps"
          format={{
            allowNegative: false
          }}
          disabled={disabled}
        />
        <Field
          xs={12}
          type="numeric"
          id={`${fieldName}.building.wellPumpEstimatedValue`}
          name={`${fieldName}.building.wellPumpEstimatedValue`}
          mode="dark"
          label="Estimated value"
          format={{
            thousandSeparator: true,
            prefix: '$',
            allowNegative: false
          }}
          disabled={disabled}
        />
        <Field
          xs={12}
          type="textarea"
          id={`${fieldName}.building.wellPumpDescription`}
          name={`${fieldName}.building.wellPumpDescription`}
          mode="dark"
          label="Description of pumps or motors"
          disabled={disabled}
        />
      </Grid>
    </SubRiskCollapsibleSection>
  );
};

WellPumpForm.propTypes = {
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

WellPumpForm.defaultProps = {
  disabled: false
};

export default observer(WellPumpForm);
